import React from 'react'

const Low = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 11 11"
      fill="none"
    >
      <circle cx="5" cy="5" r="5" fill="green" />
    </svg>
  )
}

export default Low